/**
 * @generated SignedSource<<0318d42601b6de852ad5483da46af3cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type Roles = "ADMIN" | "COWORKER_GROUP" | "CO_WORKER" | "MANAGER" | "READ_ONLY";
export type StoreInviteEmailBatch = {
  emails: ReadonlyArray<string>;
  role: Roles;
};
export type OrgStoreCreateMutation$variables = {
  address?: string | null;
  externalId?: string | null;
  invites?: ReadonlyArray<StoreInviteEmailBatch> | null;
  language: string;
  name: string;
  placeId?: string | null;
  timezone: string;
  workspaceId: string;
};
export type OrgStoreCreateMutation$data = {
  readonly workspace: {
    readonly createStore: {
      readonly id: string;
      readonly stores: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      }>;
    } | null;
  };
};
export type OrgStoreCreateMutation = {
  response: OrgStoreCreateMutation$data;
  variables: OrgStoreCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "address"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "externalId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "invites"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "language"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "placeId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "timezone"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "workspaceId"
      }
    ],
    "concreteType": "WorkspaceMutation",
    "kind": "LinkedField",
    "name": "workspace",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "address",
            "variableName": "address"
          },
          {
            "kind": "Variable",
            "name": "externalId",
            "variableName": "externalId"
          },
          {
            "kind": "Variable",
            "name": "invites",
            "variableName": "invites"
          },
          {
            "kind": "Variable",
            "name": "locale",
            "variableName": "language"
          },
          {
            "kind": "Variable",
            "name": "placeId",
            "variableName": "placeId"
          },
          {
            "kind": "Variable",
            "name": "storeName",
            "variableName": "name"
          },
          {
            "kind": "Variable",
            "name": "timezone",
            "variableName": "timezone"
          }
        ],
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "createStore",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "stores",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgStoreCreateMutation",
    "selections": (v9/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "OrgStoreCreateMutation",
    "selections": (v9/*: any*/)
  },
  "params": {
    "cacheID": "d183a47d07ea947f8488dae99e279478",
    "id": null,
    "metadata": {},
    "name": "OrgStoreCreateMutation",
    "operationKind": "mutation",
    "text": "mutation OrgStoreCreateMutation(\n  $name: String!\n  $workspaceId: ID!\n  $timezone: String!\n  $language: String!\n  $externalId: String\n  $invites: [StoreInviteEmailBatch!]\n  $placeId: String\n  $address: String\n) {\n  workspace(id: $workspaceId) {\n    createStore(storeName: $name, timezone: $timezone, locale: $language, externalId: $externalId, invites: $invites, placeId: $placeId, address: $address) {\n      id\n      stores {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "de7225ebf7f75c35b8128356baf99f76";

export default node;
